import { memo } from 'react'

import { formatTime, formatTimeWithSuffix } from 'utils/formatTime'

import { Time as StyledTime } from '../styles'

export const Time = memo(
  ({
    loaded,
    progress,
    timeLeft = false,
  }: {
    loaded: boolean
    progress: number
    timeLeft?: boolean
  }) => (
    <StyledTime loaded={loaded}>
      {loaded ? `${formatTime(progress, timeLeft)}` : '–:–'}
    </StyledTime>
  )
)

export const TimeRemaining = memo(
  ({ loaded, progress }: { loaded: boolean; progress: number }) => (
    <div>
      <StyledTime loaded={loaded}>
        {loaded ? `${formatTimeWithSuffix(progress)}` : '–:–'}
      </StyledTime>
    </div>
  )
)
